import { getQueryKey } from "@core/hooks/useSession";
import getServerSession from "@core/utils/getServerSession";
import { BillingFAQsScreen } from "@features/support";
import { GetServerSideProps } from "next";
import { NextSeo } from "next-seo";
import { QueryClient } from "react-query";
import { dehydrate } from "react-query/hydration";

const PAGE_TITLE = "Billing FAQs";

const BillingFAQsPage = (): JSX.Element => {
  return (
    <>
      <NextSeo
        title={PAGE_TITLE}
        openGraph={{
          title: PAGE_TITLE,
        }}
      />
      <BillingFAQsScreen />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const queryClient = new QueryClient();
  const session = await getServerSession(ctx);

  // Pre-load the session query
  queryClient.setQueryData(getQueryKey(), session);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

export default BillingFAQsPage;
